export const NAME_FLEX = 4;
export const VALUE_FLEX = 2.75;
